var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCriticalPoints2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "#D62828",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67523 4.20299C10.0725 3.62361 10.9275 3.62361 11.3248 4.20299L17.654 13.4345C18.1089 14.0981 17.6338 15 16.8292 15H4.17082C3.36623 15 2.89108 14.0981 3.34605 13.4345L9.67523 4.20299Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6113 14.117C10.1953 14.117 9.91793 14.0173 9.77926 13.818C9.6406 13.6187 9.57126 13.3803 9.57126 13.103C9.57126 12.8343 9.6406 12.6047 9.77926 12.414C9.9266 12.2147 10.2039 12.115 10.6113 12.115C11.0013 12.115 11.2656 12.2103 11.4043 12.401C11.5516 12.5917 11.6253 12.8257 11.6253 13.103C11.6253 13.389 11.5516 13.6317 11.4043 13.831C11.2656 14.0217 11.0013 14.117 10.6113 14.117ZM9.98726 11.478C9.90926 11.01 9.8226 10.5463 9.72726 10.087C9.6406 9.62767 9.57126 9.19433 9.51926 8.787C9.47593 8.371 9.4716 8.007 9.50626 7.695C9.5496 7.383 9.6536 7.136 9.81826 6.954C9.98293 6.772 10.2386 6.681 10.5853 6.681C10.9319 6.681 11.1919 6.772 11.3653 6.954C11.5386 7.136 11.6426 7.38733 11.6773 7.708C11.7119 8.02867 11.7033 8.397 11.6513 8.813C11.6079 9.22033 11.5386 9.65367 11.4433 10.113C11.3566 10.5637 11.2699 11.0187 11.1833 11.478C11.1833 11.478 11.1313 11.465 11.0273 11.439C10.9319 11.413 10.7846 11.4 10.5853 11.4C10.4466 11.4 10.3123 11.413 10.1823 11.439C10.0523 11.465 9.98726 11.478 9.98726 11.478Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCriticalPoints2);
export default __webpack_public_path__ + "static/media/Icon_critical_points2.dff7136dc3dd68fbf8a92701d6b6e513.svg";
export { ForwardRef as ReactComponent };